function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useDrag } from "@use-gesture/react";
import styled, { css } from "styled-components";
import React, { useCallback, useRef } from "react";
import clamp from "astrid-helpers/src/clamp";
import map from "astrid-helpers/src/map";
import { transparentizedPrimaryColor } from "../../../helpers/transparentize";
import { getRect } from "./state/rect";
import { getSize } from "./state/size";
const Root = ({
  end,
  ...props
}) => /*#__PURE__*/React.createElement("div", props);
const Styled = /*#__PURE__*/styled(Root).withConfig({
  displayName: "Styled",
  componentId: "sc-i51r6t-0"
})(["position:absolute;z-index:1;top:0;bottom:30px;width:15px;opacity:0;background-color:", ";transition:opacity 0.2s ease-in-out;cursor:col-resize;&:hover{opacity:1;}", ""], transparentizedPrimaryColor, ({
  end
}) => end ? css(["right:0;"]) : css(["left:0;"]));
export default function Trim({
  end,
  start,
  length,
  onChangeEnd,
  onReleaseEnd,
  onChangeStart,
  onReleaseStart
}) {
  const side = useRef();
  const onDrag = useDrag(useCallback(({
    args,
    last,
    first,
    event,
    movement
  }) => {
    event.stopPropagation();
    if (first) {
      side.current = args[0];
    } else if (last) {
      if (side.current === "start") {
        onReleaseStart();
      } else {
        onReleaseEnd();
      }
    } else {
      const size = getSize();
      const {
        width
      } = getRect();
      const deltaX = map(movement[0], 0, width, 0, size);
      if (side.current === "start") {
        onChangeStart(clamp(start + deltaX, 0, end - 125));
      } else {
        onChangeEnd(clamp(end + deltaX, start + 125, length));
      }
    }
  }, [end, length, onChangeEnd, onChangeStart, onReleaseEnd, onReleaseStart, start]));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled, onDrag("start")), /*#__PURE__*/React.createElement(Styled, _extends({
    end: true
  }, onDrag("end"))));
}
//# sourceMappingURL=Trim.js.map